<template>
  <div class="card">
      <div class="card-header bg-transparent text-left">
        <div class="row">
          <div class="col-10 text-center text-md-left">
            <strong>
              {{title}} {{periodText}}
            </strong>
          </div>
          <div class="col-2 text-center text-md-right">
            
            <font-awesome-icon icon="sync" @click="updateData()" rel="tooltip" title="Atualizar dados do gráfico" role="button" />
          </div>
        </div>
      </div>

      <div class="card-body">
        <bills-to-pay 
            v-if="isLoading"
            :type="type"
            :options="options"
            :chart-data="chartdata"
        />
        <font-awesome-icon v-else icon="spinner" size="2x" spin  />
      </div>

      <div class="card-footer bg-transparent text-left" v-if="pShowPeriod" >

          <div class="row" >
            <div class="col-md-6 text-center text-md-left">
              <strong>Total: </strong> {{format(total)}}
            </div>
              <div class="col-md-6 text-center text-md-right" >
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" v-bind:class="[active == 1 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 3, active = 1]" class="btn btn-sm">3 Meses</button>
                  <button type="button" v-bind:class="[active == 2 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 6, active = 2]"  class="btn btn-sm">6 Meses</button>
                  <button type="button" v-if="pShowPeriod" v-bind:class="[active == 3 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 12, active = 3]"  class="btn btn-sm">12 Meses</button>
                </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
    import billsToPay from '@/components/graphs/billsToPay.vue'
    export default {
        name: 'vwBillsToPay',
        props: [
          'height',
          'pShowPeriod',
          'title',
          'type'
        ],
        components:{
          billsToPay
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        data(){
          return {
            total: 0,
            isLoading: false,
            active: 2,
            period: 6,
            periodType: 'month',
            periodText: '6 Meses',
            chartdata: {
                labels: [],
                datasets: []
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                tooltips: {
                  enabled: true,
                  mode: 'single',
                  callbacks: {

                  }
                }
            }
          }
        },
        methods: {
            updateData: function(){
              let url 
              if(this.type == 0) {
                url = server + 'graficos/duplicatas/pagas/' + this.period 
              }else if(this.type == 1){
                url = server + 'graficos/duplicatas/pagar/' + this.period
              }
              this.isLoading = false
              fetch(url, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
              })
                  .then(response => (response.json()))
                  .then(responseJSON => {
                      let data = responseJSON.response

                      let labels = []
                      let dataset = []
                      let colors = []

                      this.chartdata.labels = []
                      this.chartdata.datasets = []
                      this.total = 0

                      for (let index = 0; index < data.length; index++) {
                          const element = data[index];
                          switch (parseInt(element.VENCIMENTO)) {
                              case 1:
                                  labels.push('Jan / ' + element.ANO)
                                  break;
                              case 2:
                                  labels.push('Fev / ' + element.ANO)
                                  break;
                              case 3:
                                  labels.push('Mar / ' + element.ANO)
                                  break;
                              case 4:
                                  labels.push('Abr / ' + element.ANO)
                                  break;
                              case 5:
                                  labels.push('Mai / ' + element.ANO)
                                  break;
                              case 6:
                                  labels.push('Jun / ' + element.ANO)
                                  break;
                              case 7:
                                  labels.push('Jul / ' + element.ANO)
                                  break;
                              case 8:
                                  labels.push('Ago / ' + element.ANO)
                                  break;
                              case 9:
                                  labels.push('Set / ' + element.ANO)
                                  break;
                              case 10:
                                  labels.push('Out / ' + element.ANO)
                                  break;
                              case 11:
                                  labels.push('Nov / ' + element.ANO)
                                  break;
                              case 12:
                                  labels.push('Dez / ' + element.ANO)
                                  break;
                              default:
                                  labels.push('Mês / ' + element.ANO)
                                  break;
                          }
                          dataset.push(element.VALOR == null ? 0 : element.VALOR)
                          this.total = parseFloat(this.total) + parseFloat(element.VALOR == null ? 0 : element.VALOR)
                      }

                      this.chartdata.labels = labels
                      this.chartdata.datasets.push({
                          label: 'Valor',
                          backgroundColor: '#f87979',
                          data: dataset
                      })

                      this.options.tooltips.callbacks.label = function(tooltipItem, data){
                          const formatter = new Intl.NumberFormat('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                              minimumFractionDigits: 2
                          })

                          // return formatter.format(value)
                          return  'Valor ' + formatter.format(data.datasets[0].data[tooltipItem.index])
                      }

                      this.isLoading = true
                  })
                  .catch(error => (console.log(error)));
            },

            format: function(value){
              const formatter = new Intl.NumberFormat('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2
              })

              return formatter.format(value)
            }
        },
        watch: {
          period: function(newVal, oldVal){
            if(newVal == 1){
              this.periodText = '3 Meses'
            }else if(newVal == 6){
              this.periodText = '6 Meses'
            }else{
              this.periodText = '12 Meses'
            }
            this.updateData()
          }
        },
        mounted(){
          this.updateData()
        }        
    }
</script>